'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var moment = _interopDefault(require('moment'));
var styledComponents = require('./styled-components.js');
var InputWithSubmitButton = require('./components/InputWithSubmitButton.js');
var OwnerResponse = require('./components/OwnerResponse.js');
var AvatarWithResponseButton = require('./components/AvatarWithResponseButton.js');
var Response = require('./components/Response.js');

/* eslint-disable react/no-array-index-key */
var ReviewListItem = function (props) {
    var _a = props.name, name = _a === void 0 ? 'Leila Klien' : _a, _b = props.score, score = _b === void 0 ? 3.7 : _b, _c = props.createdAt, createdAt = _c === void 0 ? moment().subtract(1, 'week') : _c, _d = props.text, text = _d === void 0 ? 'Wow, great stuff!' : _d, _e = props.type, type = _e === void 0 ? 'facebook' : _e, _f = props.hideResponse, hideResponse = _f === void 0 ? false : _f, _g = props.responses, responses = _g === void 0 ? [{ comment: 'omg this place is awesome' }] : _g, _h = props.responseError, responseError = _h === void 0 ? false : _h, recommendationType = props.recommendationType, responseSubmitHandler = props.responseSubmitHandler;
    var _j = React.useState(false), showReply = _j[0], setShowReply = _j[1];
    var _k = React.useState(''), response = _k[0], setResponse = _k[1];
    var toggleReply = function () {
        setShowReply(!showReply);
    };
    var onResponseChange = function (e) {
        setResponse(e);
    };
    var minHeight = hideResponse ? '100px' : '150px';
    return (React__default.createElement(styledComponents.StyledCard, { style: { minHeight: minHeight } },
        React__default.createElement("div", { style: { minHeight: minHeight, display: 'flex' } },
            React__default.createElement("div", { style: { flex: 0, minWidth: '70px' } },
                React__default.createElement(AvatarWithResponseButton, { onClick: toggleReply, name: name, type: type, hideResponse: hideResponse })),
            React__default.createElement("div", { style: { flex: 12, marginLeft: '-10px' } },
                React__default.createElement(Response, { type: type, name: name, score: score, text: text, createdAt: createdAt, recommendationType: recommendationType }))),
        !hideResponse && (React__default.createElement("div", { className: 'responseOwner' }, responses.length &&
            responses.map(function (reply) { return (React__default.createElement("div", { key: reply.comment }, reply.comment && React__default.createElement(OwnerResponse, { comment: reply.comment }))); }))),
        showReply && (React__default.createElement("div", { className: 'card-footer' },
            React__default.createElement("hr", null),
            responseError && (React__default.createElement("div", null,
                React__default.createElement("p", { className: 'alert alert-danger' },
                    " ",
                    responseError))),
            React__default.createElement(InputWithSubmitButton, { onSubmit: function () { return responseSubmitHandler(response); }, value: response, onChange: onResponseChange, title: 'Post' })))));
};

module.exports = ReviewListItem;
